import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

//Servicios
import { UsuarioService } from '@/app/services/usuario.service';
import { CatalogosService } from '@/app/services/catalogos.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';

//Modelos
import { Rol } from '@/app/models/Rol';
import { Station } from '@/app/models/Station';
import { TipoUsuario } from '@/app/models/TipoUsuario';

//Librerías externas
import {MatDialogRef} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-crear-usuario',
    templateUrl: './crear-usuario.component.html',
    styleUrls: ['./crear-usuario.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrearUsuarioComponent {
  private spinner = inject(NgxSpinnerService);

  //Ng-model
  UsuarioRQ = {
    usuario: null,
    nombre: null,
    apellidoPaterno: null,
    apellidoMaterno: null,
    email: null,
    password: 'Comb123$',
    confirmPassword: 'Comb123$',
    creadoPor: '',
    idEstacion: null,
    idRol: null,
    idTipo: 0,
    idEstatus:6
  };


  // Catálogos:
  tiposUsuario: TipoUsuario[] = [];
  roles: Rol[] = [];
  estaciones: Station[] = [];

  //Bandera auxiliar (Mostrar / ocultar campo de tipo usuario)
  motrarTipoUsuario: boolean = false;

  //Bandera global para cerrar el modal
  hasFinished: boolean = false;

  constructor
  (
    private usuarioService: UsuarioService,
    private catalogosService: CatalogosService,
    private toastr: ToastrService, 
    private router: Router,
    public dialogRef: MatDialogRef<CrearUsuarioComponent>,
    private userTokenReaderService: TokenReaderService,

  )
  {
    this.getEstaciones();
    this.getRoles();
    this.getTiposUsuario();
  }

  //Obtener catálogos
  getRoles(){
    this.catalogosService.getRoles().subscribe({
      next: (data: any)=>{
        this.roles = data.Roles;
        console.log(this.roles);
      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de roles.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getTiposUsuario(){
    this.catalogosService.getTiposUsuario().subscribe({
      next: (data: any)=>{
        this.tiposUsuario = data.Tipos;
        console.log(this.tiposUsuario);
      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getEstaciones(){
    this.catalogosService.getStations().subscribe({
      next: (data: any)=>{
        this.estaciones = data.Estaciones.map( (i: any) => {return {'label': i.IATA, 'value': i.idEstacion} } );    
        this.UsuarioRQ.idEstacion = data.Estaciones[0].idEstacion;
        console.log(this.estaciones);

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  //Submit y crear usuario
  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear un nuevo usuario?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.crearUsuario();
        }
      });
    }
  }

  crearUsuario(){
    this.spinner.show();

    // Validación auxiliar
    if(this.UsuarioRQ.idRol != 4) this.UsuarioRQ.idTipo = 0;

    //Asignar creado por desde el token del usuario autenticado
    this.UsuarioRQ.creadoPor = this.userTokenReaderService.getUserData().idUsuario;
    
    this.usuarioService.crearUsuario(this.UsuarioRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Usuario registrado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado el usuario. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }

}
